import { getCurrentDate } from "@helper/useDateFormat";

type FooterCopyrightProps = {
  testId?: string;
  className: string;
};

export function FooterCopyright({ className, testId }: FooterCopyrightProps) {
  const currentDate = new Date();
  const year = getCurrentDate("yyyy");
  const isAfterJuneFirst = currentDate >= new Date(`2025-06-01`);
  const updatedMCI = isAfterJuneFirst
    ? "MDDI (P) 015/06/2025, MDDI (P) 014/06/2025"
    : "MCI (P) 020/06/2024, MCI (P) 019/06/2024";
  return (
    <div
      data-testid={`${testId}-copyright`}
      className={`${className} text-xxs text-white-200 font-regular`}
    >
      <p className="p-0">
        {updatedMCI} SPH Digital News Copyright © <span>{year}</span> . SPH
        Media Limited. Co. Regn. No. 202120748H
      </p>
    </div>
  );
}
